import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'urlEndpoint',
  standalone: false,
})
export class UrlEndpointPipe implements PipeTransform {
  transform(url: string) {
    if (url) {
      return url.replace(/^.*\/\/[^/]+/, '');
    }
    return '';
  }
}
